// @flow
import partialUpdateDefaultSettings from './defaultSettings';
import { getDataSet } from '../lib/dataset';
import { getTargets } from './partialUpdateUtils';

export type OnAlterHistoryProps = {
  // eslint-disable-next-line
  settings: PartialUpdateSettings,
  xhr: JQueryXHR,
  params: string,
  url: string,
  // vypočítaná url z params a url bez PU targetu, zavináče, formId, timestamp parametru
  alterHistoryUrl: string,
};
/**
 Definice nastavení Partial Updatu.

 Data atributy ze kterých se parsují settings.

 Klíč je data atribut a hodnota určuje o jakou vlastnost nastavení se jedná:
 <pre>{
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings',
  }</pre>
 */
export type PartialUpdateSettings = {
  /**
   * @deprecated
   * donastavení ajaxu podle jQuery.ajax
   */
  ajax: ?Object,
  /**
   * nastavení, zda se má po dokončení PU zaktualiyovat history state prohlížeče
   */
  alterHistory: ?boolean,
  /**
   *
   */
  onAlterHistory: ?(props: OnAlterHistoryProps) => void,
  // clearCache: ?boolean, // nepoužívá se
  /**
   * @deprecated
   * eventName alias
   */
  command: ?string,
  /**
   * možnost nastavení eventu, který se na odešle na server
   */
  eventName: ?string,
  /**
   * dodefinování vlastních dat, která se odešlou při PU na server
   * data se přidají ke stávajícím
   */
  data: ?(Array<{ name: string, value: string }> | Object | string),

  /**
   * dodefinování vlastních dat, která se odešlou při PU na server
   * data se budou mergovat s odesílanými
   * tj. pokud  v mergeDatech bude parametr, který je ve formuláři nebo url, tak bude přepsán
   */
  dataMerge: ?(Array<{ name: string, value: string }> | Object | string),

  /**
   * Definovní parametrů které se na server při PU neodešlou
   */
  exceptParams: ?(Array<string> | string),
  historyScope: 'parameters' | 'allData',
  /**
   * neodešle na server widget data (frm.) uvnitř aktualizovaného targetu
   */
  removeContainerWidgetData: ?(Array<string> | string),
  /**
   * Neodešle na server formId parametr
   */
  removeFormId: ?boolean,
  /**
   * neodešle na server specifikovaná widget data
   */
  removeFormWidgetData: ?(Array<string> | string | boolean),
  /**
   * boolean true - suppresses full page redirect even if server returns 302 (Moved Temporarily)
   * and performs partial update with the result returned from page servers redirects to (when
   * target page contains no component required for partial update, content of the update area will
   * get removed!)
   * boolean false - whenever servers responds with 302 (Moved
   * Temporarily) client performs full page refresh
   */
  suppressRedirect: ?boolean,
  // suppressSubmitEvent: ?boolean,
  /**
   * nastavení timeout pro čekání na rsponse ze serveru
   */
  timeout: ?number,
  /**
   * allows to propagate or set layout context ID prefix for the RamJet server side rendering
   */
  layoutContext: ?string,
  /**
   * nastavení XHR cache
   */
  cache: ?boolean,
  // target alias
  containerId: ?string,
  /**
   * ID elementu, který pomocí PU chceme zaktualizovat
   */
  target: ?(string | Array<string>),
  // requestTarget alias
  htmlContainer: ?string,
  // pokud je potřeba ze serveru načíst jiný container než je na clientu nahrazován
  requestTarget: ?string,
  /**
   * nastaví url, která se má pomocí PU zavolat
   * Pokud není nastavena PU url vypočítá automaticky
   */
  url: ?string,
  /**
   * ID formuláře nebo tlačítka uvnitř formuláře
   */
  submitId: ?string,
  /**
   * provede zascrolování po vykonání partial updatu
   */
  scroll: ?(boolean | 'top' | 'bottom'),
  /**
   ofset pro zascrolování po vykonání partial updatu
   */
  scrollOffset: ?number,
  /**
    délka animace scrolování
  */
  scrollDuration: ?number,
  /**
    pokud se na uvnitř aktualizovaného targetu nachází element s atributem
    data-fragment="pagination" a jsou na něm dále loadedPagesParameterName, loadedPages, pageSize,
    pageSizeParameterName, tak se na základě těchto atributů aktuální stav stránkování
  */
  rememberPagination: ?boolean,
  /**
   * Funkce která se yavolá v případě vyskytnutí se chyby během vykonání partial updatu
   * Jde např. využít pro zobrazení dialogu s chybou
   */
  onError: ?(?Object) => void,
  /**
   callback alias
   */
  onAfterContentsReplace: ?(
    result: string, settings: PartialUpdateSettings) => void,
  /**
   *
   */
  onComplete: ?(?Object) => void,
  /**
   * zavolá se před vykonáním
   */
  onBeforeExecute: ?(?Object) => void,
  /**
   * override default replaceContents
   * implementace vlastního nahrazení
   */
  replaceContents: ?(
    result: string, settings: PartialUpdateSettings) => void,
  /**
   * Vykoná se před nahrazením
   */
  onBeforeContentsReplaced: ?(
    result: string, settings: PartialUpdateSettings) => void,
  /**
   příznak jestli se má nahrazovaný obsah obalit
   do DIV elementu s css třídou "partialUpdateDynamicContainer"
   může se hodit vypnout (false) generování pokud imlementujete vlastní replaceContents
   */
  generateReplacementContainer: ?boolean,
  /**
   * příznak kterým se nastaví, aby před vykonáním requestu a nahrazení targetu se provedl
   * test jestli target obsahuje změněný formulář.
   * Pokud obsahuje změněný formulář, tak se vykonání partial updatu přeruší
   * a zavolá se funkce definovaná ve vlastnosti onFormsChangesDetect
   * Pro plnou funkčnost je potřeba zinicalizovat pomocí partialUpdateMountChangesChecker
   */
  formsChangesDetection: ?boolean,
  /**
   * Funkce která se zavolá v případě, že formsChangesDetection je nastaveno na true a formulář
   * v nahrazovaném elementu byl změněn
   * Pro plnou funkčnost je potřeba zinicalizovat pomocí partialUpdateMountChangesChecker
   */
  onFormsChangesDetect: ?() => void,
  onBeforeExecute: ?({ settings: PartialUpdateSettings }) => void,
  /**
   v některých případech není potřeba uživatele zatěžovat zobrazením progressu
   tímto příznakem se nastaví,
   jestli se pro vykonávaný XHR při zavolání isInProgress bude vracet true
   na základě vyhodnocení isInProgress se může zobrazovat progress bar nebo spinner
   */
  includeToProgress: ?boolean,
  /*
   příznak, který který určuje, jestli se má nastavení brát i z dataset atributů z targetu nebo
   submitId, ale settings z dataatributů z parentů se načtou
   */
  mergeWithTargetSettings: ?boolean,
  /**
   * Příznak určuje jestli se se mají na server odesílat data ze všech formulářu v documentu (true), které mají stejný atribut action
   * Pokud se v nejakých formulářích vyskytují stejná widget data, tak se na server odešlou jen z prvního formuláře
   */
  dataFromAllFormsInDocument: ?boolean,
  /**
   nastavujte pouze metodou setPartialUpdateGlobalSettings. Global target se využívá zejména při
   pohybu historie
   Mělo by to být id elementu, které se nachází na každé stránce webu!
   */
  globalTarget: ?string,
  /**
   TUTO VLASTNOST NENASTAVUJTE!
   jedná se POUZE o POMOCNÁ VLASTNOST. Během cyklu v partial updatu se může target změnit
   pokud se tedy změní, tak se původní target do této vlastnosti
   target od request targetu se může lišit v případě,
   že pomocí partial updatu se aktualizuje více widgetů. Jinak taget s originalTarget jsou stejný
   vlastnost je potom dostupná v callbackách partial updatu, kde se s ní dá pracovat
   */
  originalTarget: ?string,
  /**
   Nastavení jestli po úspěšném vykonání PU má stav
   do historie prohlížeče pushnout nebo replacenout
   */
  historyReplaceState: ?boolean,
  /**
   pomocná properta, nastavuje jí mechanismus pro práci s historií prohlížeče
   nastavuje ji PU v okamžiku, je-li PU voláno při pop state z historie
   */
  historyPopState: ?boolean,
  /**
   pomocná properta, nastavuje jí mechanismus pro práci s historií prohlížeče
   */
  historyDirection: 'next' | 'prev',
  // focusAfterContentsReplace: ?string,
  /**
   příznak který povoluje po vykonání partialupdatu focus na element, který byl focusnut před.
   pokud byl focusnut nějaký input nebo textarea, tak se cursor umístí na pozici, kde byl předtím.
   */
  persistFocus: ?boolean,
  /**
   * pole selectorů, které se mají nahradit.
   * Použitelné, když například uživatel má zobrazený nějaký pupup a s partialupdatem jej nechceme zavřít.
   * takže se do pole vyjmenují všechny elementy mimo popupu. Využívá se např. v edeem v listingu při filtrování popup filtrů.
   */
  pick: ?Array<string>,
  /**
   * Pokud se PU volá přes POST, tak všechny parametry z url se nebudou odesílat jako QueryString Parametrs, ale odešlou se jako Form Data
   * To eleminuje chybu kdy url je moc dlouhá. Což bývá maximálně 2083 znaků.
   */
  moveUrlQueryParamsToFormDataOnPost: ?boolean,

  persistFocus: ?boolean,
  /**
   * pole selectorů, které se nemají nahrazovat.
   * Pokud element ze selectoru příde v response a zároveň se vykytuje v aktuálním DOMu tak se zachová ten v DOMu
   * Technicky se ale nahradí.
   */
  omit: ?Array<string>,
  headers?: Object,
};

window.partialUpdateGlobalSettings = {
  ...partialUpdateDefaultSettings,
};
export const getGlobalPartialUpdateSettings = (): PartialUpdateSettings =>
  window.partialUpdateGlobalSettings;

/**
 * Na defaultní nastavení pro celí projekt
 */
export const setPartialUpdateDefaultSettings = (settings: PartialUpdateSettings) => {
  window.partialUpdateGlobalSettings = {
    ...partialUpdateDefaultSettings,
    ...settings,
  };
};

export const settingsDataAttributesMap = {
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-data-merge': 'dataMerge',
  'data-pu-data-merge': 'dataMerge',
  // nechat na konci. Settings se mergují do všech nasbíraných
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings',
};

export const getElementPartialUpdateSettings = (element) => {
  let settings = {};
  if (element) {
    Object.keys(settingsDataAttributesMap)
      .forEach((dataset) => {
        const prop = settingsDataAttributesMap[dataset];
        const datasetValue = getDataSet(element, dataset.replace(/^data-/, ''));
        if (datasetValue != null) {
          if (prop === 'settings') {
            settings = {
              ...settings,
              ...datasetValue,
            };
          } else {
            settings[prop] = datasetValue;
          }
        }
      });
  }
  return settings;
};


// Přečte nastavení partial update ze všech closest
// elementů a mergne je do sebe
// - excludePartialUpdateContainerSettings - pokud je true,
// tak vynechá všechna nastavení z parentího partial update containeru
// - excludePartialUpdateContainerSettings - pokud je Array<String>,
// tak vynechá jen specifikovaná nastavení z parentího partial update containeru
export const getClosestPartialUpdateSettings = (
  settings: PartialUpdateSettings | HTMLElement,
  excludePartialUpdateContainerSettings: boolean | Array<string>,
): PartialUpdateSettings => {
  let targetElement;
  let mergeWithTargetSettings;
  let closestSettings = {};

  if (settings instanceof HTMLElement) {
    targetElement = settings;
  } else {
    const {
      submitId,
    } = settings;
    mergeWithTargetSettings = settings.mergeWithTargetSettings;
    const firstTarget = getTargets(settings)[0];
    targetElement = document.getElementById(firstTarget || submitId);
  }

  const startClosestElement = mergeWithTargetSettings == null || mergeWithTargetSettings === true ?
    targetElement : targetElement.parentElement;

  if (targetElement) {
    Object.keys(settingsDataAttributesMap)
      .forEach((dataset) => {
        const prop = settingsDataAttributesMap[dataset];
        let closestDatasetElement;
        if (excludePartialUpdateContainerSettings) {
          if (Array.isArray(excludePartialUpdateContainerSettings)) {
            if (excludePartialUpdateContainerSettings.includes(prop)) {
              closestDatasetElement = startClosestElement.closest(
                `[${dataset}]:not(.isPartialUpdateContainer)`);
            } else {
              closestDatasetElement = startClosestElement.closest(`[${dataset}]`);
            }
          } else {
            closestDatasetElement = startClosestElement.closest(
              `[${dataset}]:not(.isPartialUpdateContainer)`);
          }
        } else {
          closestDatasetElement = startClosestElement.closest(`[${dataset}]`);
        }
        if (closestDatasetElement) {
          const datasetValue = getDataSet(closestDatasetElement, dataset.replace(/^data-/, ''));
          if (prop === 'settings') {
            closestSettings = {
              ...closestSettings,
              ...datasetValue,
            };
          } else {
            closestSettings[prop] = datasetValue;
          }
        }
      });
  }
  return closestSettings;
};

export const getPaginationSubmitData = (
  settings: PartialUpdateSettings | HTMLElement,
): Array => {
  let element;

  if (settings instanceof HTMLElement) {
    element = settings;
  } else {
    const {
      submitId,
    } = settings;
    const firstTarget = getTargets(settings)[0];
    element = document.getElementById(firstTarget || submitId);
  }
  // jestliže je uvnitř widgetu pagination widget,
  // tak z něj získá aktuální počet načtených stránek
  // a obsah refreshne s parametrem pageSize
  const pagination = element.querySelector('[data-fragment="pagination"]');
  const data = [];
  if (pagination) {
    const paginationProps = getDataSet(pagination);
    const {
      loadedPagesParameterName,
      loadedPages,
      pageSize,
      pageSizeParameterName,
      pageNumber,
      pageNumberParameterName,
    } = paginationProps;

    if (loadedPagesParameterName && loadedPages != null && pageSize != null && pageNumber != null) {
      data.push({
        name: pageSizeParameterName,
        value: pageSize * (loadedPages),
      });
      data.push({
        name: pageNumberParameterName,
        value: (pageNumber - loadedPages) + 1,
      });
    }
  }
  return data;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/PartialUpdateSettings.js